import React from 'react';
import PropTypes from 'prop-types';
import PricingCard from './PricingCard';
import PricingCardTwo from './PricingCardTwo';

const PricingSection = ({ title }) => (
  <div>
    <div className="text-center mb-8 flex flex-col">
      <h1 className="leading-none md:leading-tight font-sans text-shop-dark-green text-4xl w-full md:w-3/4 mb-4 flex self-center justify-center">
        {title}
      </h1>
    </div>
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-12">
      <PricingCard title="Lite" price="9" surveys="50" />
      <PricingCard title="Starter" price="19" surveys="250" />
      <PricingCard title="Growth" price="49" surveys="1000" />
      <PricingCard title="Big" price="129" surveys="5000" />
    </div>
    <div className="md:w-full flex flex-col text-center mb-8">
      <h3 className="text-shop-dark-green mb-4 font-bold text-xl">
        All Plans Include
      </h3>
      {/* <p className="font-sans text-gray-700 mb-4">Unlimited Surveys Sent</p> */}
      <p className="font-sans text-gray-700 mb-4">30 Day Free Trial</p>
      <p className="font-sans text-gray-700 mb-4">Easy, 5 Minute Setup</p>
      <p className="font-sans text-gray-700 mb-4">
        Automatic Survey Sending - Customizable days after each sale
      </p>
      <p className="font-sans text-gray-700 mb-4">
        Survey Throttling - Prevents customers from being over surveyed
      </p>
      <p className="font-sans text-gray-700 mb-4">
        Customizable Emails - Colors, Logo, Copy, Thank You
      </p>
      {/* <p className="font-sans text-gray-700 mb-4">
        Tag your responses (Coming soon)
      </p>
      <p className="font-sans text-gray-700 mb-4">
        Slack Integration (Coming soon)
      </p> */}
      {/* <p className="font-sans text-gray-700 mb-4">
        Daily, Weekly or Monthly Reports
      </p> */}
    </div>
  </div>
);

PricingSection.propTypes = {
  title: PropTypes.string.isRequired,
};

export default PricingSection;
